import React, { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";

const SSOLoginRedirect: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const code = params.get("code");
    const source_url = params.get("source_url");

    if (!code || !source_url) {
      console.error("Missing code or state");
      return;
    }

    const separator = source_url.includes("?") ? "&" : "?";

    const redirectUrl = `${source_url}${separator}code=${code}`;

    window.location.replace(redirectUrl);
  }, []);

  return <Box sx={{ position: "fixed", height: "100%", width: "100%" }}>
    <CircularProgress size={60} />
  </Box>;
};

export default SSOLoginRedirect;